export default function zoomImg() {
  const modal = document.querySelector('.modalWrap');
  const modalImg = document.querySelector('.modalContent');
  const images = document.querySelectorAll('.clickable');
  const closeBtn = document.querySelector('.close');
  const modalBg = document.querySelector('.modalBg');

  if (!modal || !modalImg || !images || !closeBtn || !modalBg) return;

  const openModal = (imgSrc) => {
    if (window.innerWidth <= 1024) {
      modal.classList.add('_open');
      modalImg.src = imgSrc;
      document.body.classList.add('_modalOpen');
    }
  };

  images.forEach((image) => {
    image.addEventListener('click', (event) => {
      openModal(event.target.src);
    });
  });

  const closeModal = () => {
    modal.classList.remove('_open');
    document.body.classList.remove('_modalOpen');
    modalImg.src = '';
  };

  closeBtn.addEventListener('click', closeModal);
  modalBg.addEventListener('click', closeModal);

  window.addEventListener('click', (event) => {
    if (event.target === modal || event.target === modalBg) {
      closeModal();
    }
  });
}
